import { RouteProps } from "react-router-dom";
import Hearder from "./header/Hearder";
import Footer from "./footer/Footer";

const GlobalStructureWebsite = (props: RouteProps) => {
  const { children } = props;
  return (
    <>
      <Hearder/>
      {children}
      <Footer/>
    </>
  );
};

export default GlobalStructureWebsite;
